import React from 'react';
import './ScrollDownButton.css';

const ScrollDownButton = ({ onScrollClick }) => {
  const handleButtonClick = () => {
    onScrollClick?.();
    window.scrollTo({
      top: document.documentElement.clientHeight,
      behavior: 'smooth',
    });
  };

  return (
    <button
      className="scroll-down-button"
      onClick={handleButtonClick}
      aria-label="Scroll down"
    >
      ▼
    </button>
  );
};

export default ScrollDownButton;
